import React, { useState } from 'react';
import { ZoomIn } from 'lucide-react';

export const ProductGallery = ({ product }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <div className="space-y-4">
      <div className="relative aspect-square rounded-lg overflow-hidden bg-gray-100 group">
        <img
          src={product.gallery[selectedImage]}
          alt={product.name}
          data-testid="product-gallery-main"
          className={`w-full h-full object-cover transition-transform duration-300 ${
            isZoomed ? 'scale-150 cursor-zoom-out' : 'cursor-zoom-in'
          }`}
          onClick={() => setIsZoomed(!isZoomed)}
        />
        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2">
          <ZoomIn className="h-5 w-5 text-[#001B2A]" />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-2">
        {product.gallery.map((image, index) => (
          <button
            key={`${product.id}-gallery-${index}`}
            onClick={() => setSelectedImage(index)}
            className={`aspect-square rounded-lg overflow-hidden border-2 transition-all ${
              selectedImage === index
                ? 'border-[#7B1E2B] shadow-lg'
                : 'border-gray-200 hover:border-gray-400'
            }`}
          >
            <img src={image} alt={`${product.name} view ${index + 1}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};
